import { useState, useEffect } from 'react'
import { NextSeo } from 'next-seo'
import { useRouter } from 'next/router'
import { toast } from 'react-toastify'

import { SectionPart, SectionItens, ListItens, Footer, Container } from 'styles/Partners'

import { Button } from 'components'

import { useUser } from 'context/user-context'

import PeopleIcon from '@material-ui/icons/People'
import WorkIcon from '@material-ui/icons/Work'
import MonetizationOn from '@material-ui/icons/MonetizationOn'

export const Partner = () => {
  const router = useRouter()

  const { user } = useUser()

  const [isPartner, setIsPartner] = useState(false)
  const [isLogged, setIsLogged] = useState(false)

  const handlePartner = async () => {
    try {
      router.push('/indicacao-de-empresas')
    } catch (error) {
      toast.info('Você ainda não é um Parceiro.')
    }
  }

  const handleRegisterPartner = async () => {
    try {
      router.push('/cadastro-de-parceiro')
    } catch (error) {}
  }

  useEffect(() => {
    const isLoged = async () => {
      try {
        if (!!user) {
          setIsLogged(true)
        }

        if (user.partner) {
          setIsPartner(true)
        }
      } catch (error) {
        setIsLogged(false)
      }
    }
    isLoged()
  }, [user])

  return (
    <Container logged={isLogged}>
      <NextSeo title={'Kavod Lending | Parceria'} description='KavodLending | Partnership' />
      <SectionPart>
        <h2>Aumenta a sua renda sendo um parceiro da Kavod Lending e indicando empresas</h2>
        <h4>Se você ainda não é um parceiro Kavod, cadastre-se para começar a indicar empresas</h4>
        <div>
          {isLogged && !isPartner && (
            <Button width='100%' ml={1} mr={1} onClick={handleRegisterPartner} style={{ maxWidth: '180px' }}>
              Realizar cadastro
            </Button>
          )}
          {isLogged && isPartner && (
            <Button width='100%' ml={1} mr={1} onClick={handlePartner} style={{ maxWidth: '180px' }}>
              Indicar empresa
            </Button>
          )}
          {!isLogged && (
            <Button width='100%' ml={1} mr={1} onClick={handleRegisterPartner} style={{ maxWidth: '180px' }}>
              Realizar cadastro
            </Button>
          )}
          {!isLogged && (
            <Button
              border={3}
              variant='outlined'
              width='100%'
              ml={1}
              mr={1}
              onClick={handlePartner}
              style={{ color: '#fff', borderColor: '#fff', maxWidth: '180px' }}
            >
              Já sou parceiro
            </Button>
          )}
        </div>
      </SectionPart>
      <SectionItens>
        <ListItens>
          <li>
            <PeopleIcon style={{ color: 'var(--blue)', fontSize: 80 }} />
            <a>1. Cadastre-se como parceiro</a>
            <p>Basta fazer um simples cadastre e, após aprovado, você já poderá começar a fazer as indicações</p>
          </li>
          <li>
            <WorkIcon style={{ color: 'var(--blue)', fontSize: 80 }} />
            <a>2. Indique empresas</a>
            <p>Quanto mais empresas indicar, maior a chance de aumentar a sua renda como Parceiro Kavod</p>
          </li>
          <li>
            <MonetizationOn style={{ color: 'var(--blue)', fontSize: 80 }} />
            <a>3. Aumente a sua renda</a>
            <p>Para cada empresa indicada e aprovada, você receberá uma comissão da Kavod</p>
          </li>
        </ListItens>
      </SectionItens>
      <Footer>
        <div>
          <h4>Kavod Lending Tecnologia e Serviços 2018 © Todos os direitos reservados</h4>
          <img src='/img/logo-kavod-footer.svg' />
        </div>
      </Footer>
    </Container>
  )
}

export default Partner
